import axios from 'axios';
import { createContext, useState, useEffect } from 'react';
// import { defaultUserData } from '../utils/defaultDataUser';
import { userRoutes } from '../utils/RoutesApi';
import { useB3Connection } from '../hooks/useB3Connection';

const ONE_MINUTE_COUNTER = 1000 * 60 * 1;

export const AuthContext = createContext({});
export const AuthProvider = (props) => {
  const getDataUser = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_USER_VERSION)
  );
  const [permissions, setPermissions] = useState(getDataUser.UserType ?? []);

  const [user, setUser] = useState(
    // defaultUserData

    {
      ...getDataUser.user,
      data_trial: getDataUser.dias_trial,
    }
  );

  const [title, setTitle] = useState('');
  const {
    connected: b3Connected,
    checking: b3Checking,
    status: b3Status,
  } = useB3Connection(user, setUser);
  const [notifyCount, setNotifyCount] = useState(0);

  // useEffect(() => {
  //   getDataUSer();
  // }, []);
  // async function getDataUSer() {
  //   await axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}${userRoutes.USER_REFRESH_PERMISSIONS}`
  //     )
  //     .then((response) => {

  //       setUser(response.data.user);
  //     })
  //     .catch((err) => {
  //     });
  // }

  useEffect(() => {
    let obj = {
      ...getDataUser,
      user: user,
    };
    if (obj) {
      localStorage.setItem(
        process.env.REACT_APP_USER_VERSION,
        JSON.stringify(obj)
      );
    }
  }, [user]);
  useEffect(() => {
    let interval;

    const startInterval = () => {
      interval = setInterval(async () => {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL}${userRoutes.USER_REFRESH_PERMISSIONS}`
          )
          .then((response) => {
            if (
              getDataUser.user.status_pagamento !==
              response.data.user.status_pagamento
            ) {
              const newUser = {
                ...getDataUser.user,
                status_pagamento: response.data.user.status_pagamento,
              };
              localStorage.setItem(
                process.env.REACT_APP_USER_VERSION,
                JSON.stringify({ ...getDataUser, user: newUser })
              );
            }
            if (permissions.length !== response.data.UserType.length) {
              setPermissions(response.data.UserType);
              localStorage.setItem(
                process.env.REACT_APP_USER_VERSION,
                JSON.stringify({
                  ...getDataUser,
                  UserType: response.data.UserType,
                })
              );
            }
          })
          .catch((err) => {
          });
      }, ONE_MINUTE_COUNTER);
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearInterval(interval);
      } else {
        startInterval();
      }
    };

    // Inicia o intervalo se a página estiver visível
    if (!document.hidden) {
      startInterval();
    }

    // Listener para mudanças de visibilidade
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user]);

  async function updateUser(newDataUser) {
    let newUser = newDataUser;
    if (newUser) {
      if (newUser.profile.image) {
        const isValidProfileImage = !!newUser.profile.image.match(
          'https://storage.googleapis.com/ibox6-wordpress.appspot.com/'
        );
        if (!isValidProfileImage) {
          newUser.profile.image =
            process.env.REACT_APP_API_URL + newUser.profile.image;
        }
      }
      if (newUser.profile.banner) {
        const isValidProfileBanner = !!newUser.profile.banner.match(
          'https://storage.googleapis.com/ibox6-wordpress.appspot.com/'
        );
        if (!isValidProfileBanner) {
          newUser.profile.banner =
            process.env.REACT_APP_API_URL + newUser.profile.banner;
        }
      }

      return newUser;
    }
    return newUser;
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        b3Connected,
        b3Checking,
        b3Status,
        setUser,
        title,
        setTitle,
        setNotifyCount,
        notifyCount,
        updateUser,
        permissions,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
